import { disclosureTriggerInteractionClassName } from '@/components/ui/control-styles'

/**
 * Header navigation follows the sidebar's interaction hierarchy:
 * neutral feedback while hovering/focusing, persistent accent styling while open.
 */
export const portalNavTriggerClassName = `group/header-nav ${disclosureTriggerInteractionClassName}`
